var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('MovieBg',{staticClass:"movie-bg"}),_c('Introduction',{staticClass:"introduction"}),_c('Copyright',{staticClass:"copyright"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }